import { useCallback } from "react";
import InsuredCard from "../insured/InsuredCard";
import { MEMBERS } from "../wizardUtils";

const MEMBER_LABEL = Object.fromEntries(MEMBERS.map((m) => [m.key, m.label]));

// Applies an update to nested state via a dot-path like "preExisting.condition".
function updateAtPath(target, path, value) {
  const parts = path.split(".");
  const next = { ...target };
  if (parts.length === 1) {
    next[parts[0]] = value;
  } else if (parts.length === 2) {
    next[parts[0]] = { ...(next[parts[0]] || {}), [parts[1]]: value };
  } else if (parts.length === 3) {
    next[parts[0]] = {
      ...(next[parts[0]] || {}),
      [parts[1]]: {
        ...((next[parts[0]] || {})[parts[1]] || {}),
        [parts[2]]: value,
      },
    };
  }
  return next;
}

export default function InsuredDetails({ state, setState, errors, activeIdx = 0 }) {
  const setIns = useCallback(
    (mKey, path, value) => {
      setState((s) => {
        const cur = s.insured[mKey] || {};
        return {
          ...s,
          insured: {
            ...s.insured,
            [mKey]: updateAtPath(cur, path, value),
          },
        };
      });
    },
    [setState]
  );

  const members = state.selectedMembers;
  const total = members.length;
  const idx = Math.min(activeIdx, Math.max(0, total - 1));
  const mKey = members[idx];

  return (
    <div data-testid="wizard-step-insured">
      <h2 className="text-3xl sm:text-4xl font-medium tracking-tight mb-2">
        Insured details
      </h2>
      <p className="text-secondary-brand mb-6 leading-relaxed">
        {total > 1
          ? `Member ${idx + 1} of ${total} — tell us about ${MEMBER_LABEL[mKey] || mKey}.`
          : "Please share the following for the person being insured."}
      </p>

      {total > 1 && (
        <div className="flex items-center gap-2 mb-8" data-testid="member-substeps">
          {members.map((k, i) => (
            <div
              key={k}
              className={`h-1.5 rounded-full transition-all ${
                i === idx
                  ? "w-8 accent-bg"
                  : i < idx
                  ? "w-4 accent-bg opacity-50"
                  : "w-4 bg-subtle"
              }`}
              title={MEMBER_LABEL[k] || k}
            />
          ))}
        </div>
      )}

      {mKey && (
        <InsuredCard
          key={mKey}
          mKey={mKey}
          idx={idx}
          ins={state.insured[mKey] || {}}
          errors={errors}
          setIns={setIns}
        />
      )}
    </div>
  );
}
